export const PASSWORD_MIN_CHARS_COUNT = 12;
